
<template>
  <div :style="mainContentViewHeight" class="main_center">
    <div class="table_header">
    <div class="list_top">
        <div class="pageTitle">评标专家评价档案</div>
      <div class="search">
        <el-input
          class="my_input height_four"
          :placeholder="placeholderArea"
          v-model="searchKey"
          @keyup.enter.native="searchClick"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="searchClick" class="height_four">搜索</el-button>
        <el-button size="mini" type="text" @click="moreSearchItem = true" class="height_four">更多搜索<i class="el-icon-arrow-down"></i></el-button>
      </div>
    </div>
      <searchBox
            :dialogVisible.sync="moreSearchItem"
            @dialogCancle="dialogCancle"
            title="更多筛选"
        >
            <div class="search-drawer">
                <el-form label-position="top" :model="moreSearchForm">
                    <el-form-item label="数据所属部门：">
                    <select-depart-tree 
                    ref="selectDepartTreeRef"
                    :type="'2'"
                    :modelValue.sync="moreSearchForm.superviseDeptCodeList"  
                    :isMultiple="true" 
                    @handleDeptType="(val)=>changeDept(val,'5')" >
                    </select-depart-tree>
                </el-form-item>
                </el-form>
                <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
        </div>
            </div>
            
				</searchBox>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="日常评价" name="daily"></el-tab-pane>
        <el-tab-pane label="年度考核" name="annual"></el-tab-pane>
      </el-tabs> -->
    </div>
    <template v-if="activeName==='daily'">
      <dailyList ref="dailyListRef"></dailyList>
    </template>
    <template v-if="activeName==='annual'">
      <annualList ref="annualListRef"></annualList>
    </template>
  </div>
</template>

<script>
import dailyList from "./dailyList";
import annualList from "./annualList";
import { mapState } from "vuex";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
  props: ["mainContentViewHeight"],
  components: {
    dailyList,
    annualList,
    selectDepartTree
  },
  data() {
    return {
      activeName: "daily",
      placeholderArea: "请输入项目编号、项目名称关键字",
      searchKey: "",
      historyid: "",
      tradeId:'',
      moreSearchItem: false,
      moreSearchForm:{
                superviseDeptCodeList:[]
            },
    };
  },
  watch: {
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){
            this.searchClick();
          }
        }
      }
    },
	computed: {
        ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    })
	},
  activated() {
    // this.$refs.rewardInfoListRef.queryData();
    this.activeName = this.$route.query.type
      ? this.$route.query.type
      : this.activeName;
    this.searchClick();
  },

  computed:{
		...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
	},
  methods: {
    searchClick() {
        this.moreSearchForm.superviseDeptCodeList= this.moreSearchForm.superviseDeptCodeList.length==0?this.uerdefultOptionCode:this.moreSearchForm.superviseDeptCodeList
      if (this.activeName == "daily") {
        this.$nextTick(() => {
          //   this.$refs.dailyListRef.getDataList(this.searchKey)
          this.$refs.dailyListRef.getParentKeyAndSerach(this.searchKey, this.moreSearchForm.superviseDeptCodeList);
        });
      }
      if (this.activeName == "annual") {
        this.$nextTick(() => {
          this.$refs.annualListRef.getDataList(this.searchKey,this.moreSearchForm.superviseDeptCodeList);
        });
      }
    },
    handleClick(tab, event) {
      this.searchClick();
    },
    searchBtn(){
       this.searchClick();
     },
    refresh(){
        this.moreSearchForm.superviseDeptCodeList=[]
        // 重置默认所属数据
        if( this.$refs.selectDepartTreeRef){
        this.$refs.selectDepartTreeRef.getUserTreeOption()
        }
        this.searchBtn();
    },
    changeDept(val,str){//切换部门
            this.moreSearchForm.superviseDeptCodeList=[]
            if(str==='5'){
            // 多选
                val.forEach((item,index)=>{
                if( item.type!=="region"){
                    this.moreSearchForm.superviseDeptCodeList.push(item.code)
                }
            })
            }
        },
    dialogCancle(){
            this.moreSearchItem = false
        },
  }
};
</script>
<style lang="scss">
.table_header{
    .search{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
 
}
</style>
<style lang="scss" scoped>
$main-color: #1890ff;
.table_header {
  background: #ffffff;
  padding:0  24px;
  padding-top:24px;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  position: relative;

  .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
    }
  .list_top{
    display: flex;
    align-items: center;
    }
  .search {
    width:calc(100% - 145px);
    height:40px;
    float: none;
    display: flex;
    justify-content: center;
    align-items: center;
    > .my_input {
      width: 500px;
    }
    > .el-button--primary {
      background-color: $main-color;
      border-color: $main-color;
    }
  }
}
.table-body {
  margin: 16px 24px;
  background: #ffffff;
  padding: 15px 24px;
  margin-bottom: 0;
  .opt-btn {
    margin-bottom: 16px;
  }
}
</style>
